module.exports = __webpack_public_path__ + "img/brunjar-qr-code-ecommerce-survey.5ba9ce34.png";